module.exports = __webpack_public_path__ + "img/icon-ecp.6e2bf1c1.svg";